import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAiTokens: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"ai-tokens, credits"} maskId="square-filled-radius-0-stroke-1-IconAiTokens"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM10.25 10.0986L7 11.3486V12.3486L10.25 13.5986L11.5 16.8486H12.5L13.75 13.5986L17 12.3486V11.3486L13.75 10.0986L12.5 6.84863H11.5L10.25 10.0986Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAiTokens;
